const monthMap = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11,
} as const;

const isValidMoveInMonth = (param: string) => {
  const regex = /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)-\d{4}$/;
  if (!regex.test(param)) return false;

  const [monthStr, yearStr] = param.split("-");
  const inputMonth = monthMap[monthStr as keyof typeof monthMap];
  const inputYear = parseInt(yearStr, 10);

  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  if (inputYear < currentYear) return false;
  if (inputYear === currentYear && inputMonth < currentMonth) return false;

  return true;
};

export default isValidMoveInMonth;
